import { PropsWithChildren } from 'react';

const H3 = (props: PropsWithChildren<any>) => {
    const {
        className = '',
        ...otherProps
    } = props;
    return <h3 {...otherProps} className={`${className} ds-text-heading--xl`}>{props.children}</h3>;
}
export default H3;